import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { FilterSelect } from "@td/ui";
import { useTypes } from "../contexts/types-context";
import { translate } from "@td/shared_utils";

const filterDropdownProps = {
  style: {
    minWidth: 154,
  },
  "data-testid": "task-type-filter",
};

const TaskTypeFilter = React.memo((props) => {
  const taskTypes = useTypes();

  const options = useMemo(() => {
    return Object.values(taskTypes).map(type => ({
      value: type,
      label: translate(null, "care_team_tasks.types", type.replace("TASKTYPE_", "")),
    }));
  }, [taskTypes]);

  return (
    <FilterSelect
      {...props}
      isMulti
      options={options}
      label={translate(null, "care_team_tasks.filters.fields.task_type", "label")}
      placeholder={translate(null, "care_team_tasks.filters.fields.task_type", "placeholder")}
      filterDropdownProps={filterDropdownProps}
    />
  );
});

TaskTypeFilter.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

TaskTypeFilter.displayName = "TaskTypeFilter";

export default TaskTypeFilter;
